import ModalStack from '@/components/Custom/ModalStack';

export default function PrivateOrganizationPersonAddLayoutRoute() {
  return <ModalStack />;
}
